<script setup lang="ts">
    import { ref, reactive, onMounted, defineProps} from 'vue';
    import Swal from 'sweetalert2';
    import { watch } from 'vue';
    import axios from 'axios';
    import NavbarLanding from '@/pages/components/Generales/NavbarInd.vue';

    const props = defineProps<{
        banner: string,
    }>();

//     const sectionZIndex = ref(60); // Mayor que el Navbar (50) inicialmente

// const handleScroll = () => {
//   // Cuando hay scroll (cualquier desplazamiento), z-index se hace 40 (detrás del Navbar)
//   // Cuando está en el tope (scrollY = 0), z-index vuelve a 60 (delante del Navbar)
//   sectionZIndex.value = window.scrollY === 0 ? 60 : 40;
// };

// onMounted(() => {
//   window.addEventListener('scroll', handleScroll);
//   // Verificar estado inicial al cargar
//   handleScroll();
// });

// onUnmounted(() => {
//   window.removeEventListener('scroll', handleScroll);
// });

    interface FormField {
        id: keyof typeof formData
        icon: string
        label: string
    }

    const fields = ref<FormField[]>([
        { id: 'nombre', icon: 'fa-user', label: 'Nombre(s) *' },
        { id: 'apellidos', icon: 'fa-user', label: 'Apellido(s) *' },
        { id: 'email', icon: 'fa-envelope', label: 'Email *' },
        { id: 'telefono', icon: 'fa-phone', label: 'Teléfono *' }
    ]);

    // Estados reactivos
    const activeStep = ref(1);
    const showSuccess = ref(false);
    const formData = reactive({
        nombre: '',
        apellidos: '',
        email: '',
        telefono: '',
        nivel: '',
        carrera: '',
        modelo: '',
        recaptcha: '',
        campus: props.banner,
    });

    const niveles = ref<Array<{ value: string; text: string }>>([]);
    // Luego en tu método de carga inicial
    const loadNiveles = async () => {
        try {
            const file = `../../assets/json/${formData.campus}.json`;
            const response = await fetch(file);
            const data = await response.json();
            
            // Extraer las claves del JSON
            const keys = Object.keys(data);
            
            // Mapear a formato legible
            niveles.value = keys.map(key => ({
            value: key,
            text: key.charAt(0).toUpperCase() + key.slice(1).replace('maestria', 'maestría')
            }));
            
        } catch (error) {
            console.error("Error cargando niveles:", error);
        }
    };

    const carreras = ref<Array<{ value: string; text: string }>>([]);
    const modelos = ref<Array<{ value: string; text: string }>>([]);

    // Expresiones regulares
    const regex = {
        email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
        string: /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ ]+$/,
        telefono: /^\d{10}$/
    }

    // Validaciones
    const validateContact = () => {
        if (!regex.string.test(formData.nombre.trim())) {
            showError('Por favor ingresa un nombre válido.');
            return false;
        }
        if (!regex.string.test(formData.apellidos.trim())) {
            showError('Por favor ingresa apellido(s) válido(s).');
            return false;
        }
        if (!regex.email.test(formData.email.trim())) {
            showError('Por favor ingresa un correo electrónico válido.');
            return false;
        }
        if (!regex.telefono.test(formData.telefono.trim())) {
            showError('Por favor ingresa un teléfono válido a 10 dígitos.');
            return false;
        }
        return true;
    }

    const validateStudies = () => {
        if (!formData.nivel) {
            showError('Por favor elige el nivel de estudios.');
            return false;
        }
        if (!formData.carrera) {
            showError('Por favor elige una carrera.');
            return false;
        }
        if (!formData.modelo) {
            showError('Por favor elige el modelo.');
            return false;
        }
        return true;
    }

    // Navegación del formulario
    const handleStep = (direction: 'next' | 'prev') => {
        if (direction === 'next' && validateContact()) {
            activeStep.value = 2;
        } else if (direction === 'prev') {
            activeStep.value = 1;
        }
    }

    // Cargar carreras
    const loadCarreras = async () => {
        formData.carrera = ''
        formData.modelo = ''
        modelos.value = []

        try {
            const file = `../../assets/json/${formData.campus}.json`;
            const response = await fetch(file);
            const data = await response.json();
            
            if (file) {
                console.log(file);
            }

            carreras.value = data[formData.nivel].map((item: any) => ({
                value: item.oferta,
                text: item.oferta
            }));

            // Si solo hay 1 carrera después de cargar
            if (carreras.value.length === 1) {
                formData.carrera = carreras.value[0].value;
                await loadModelos();
            }
            
        } catch (error) {
            showError('Error al cargar las carreras');
            console.error(error);
        }
    }

    // Cargar modelos
    const loadModelos = async () => {
        try {
            const file = `../../assets/json/${formData.campus}.json`;
            const response = await fetch(file);
            const data = await response.json();
            
            const selectedCarrera = data[formData.nivel].find(
                (item: any) => item.oferta === formData.carrera
            );
            
            modelos.value = selectedCarrera.nivel.map((nivel: any) => ({
                value: nivel.id,
                text: nivel.name === 'Escolarizado' ? `${nivel.name} (presencial)` :
                        nivel.name === 'Ejecutivo' ? `${nivel.name} (presencial 1 vez por semana)` :
                        nivel.name
            }));

            if (modelos.value.length === 1) {
                formData.modelo = modelos.value[0].value;
            }
            
        } catch (error) {
            showError('Error al cargar los modelos');
            console.error(error);
        }
    }

    // Enviar formulario
    const submitForm = async () => {
        if (!validateContact() || !validateStudies()) return

        try {
            const form = new FormData();
            // Object.entries(formData).forEach(([key, value]) => {
            //     form.append(key, value)
            // });
            form.append('nombre', formData.nombre);
            form.append('apellidos', formData.apellidos);
            form.append('email', formData.email);
            form.append('telefono', formData.telefono);
            form.append('nivel', formData.nivel);
            form.append('carrera', formData.carrera);
            form.append('modelo', formData.modelo);
            form.append('campus', formData.campus);
            form.append('g-recaptcha-response',formData.recaptcha);
            form.append('url', window.location.href);
            
            // const response = await fetch('/src/static/js/scripts/sendAPI.php', {
            // const response = await fetch('https://humanitas.edu.mx/assets/sendAPI2.php', {
            //     method: 'POST',
            //     body: form
            // });
            console.log(form.keys);

            Swal.fire({
                title: 'ENVIANDO...',
                text: 'ESTAMOS ENVIANDO SUS DATOS. NO CIERRE LA VENTANA',
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                    axios.post('https://humanitas.edu.mx/assets/sendAPI2.php', form, {
                        headers: {'Content-Type': 'multipart/form-data',},
                        responseType: 'json',
                    })
                        .then((response: { data: { error: any; descripcion: any; }; }) => {
                            console.log(response);
                            Swal.fire({
                                title: '¡ENVIADO!',
                                text: 'NUESTROS EJECUTIVOS SE PONDRÁN EN CONTACTO CONTIGO LO ANTES POSIBLE.',
                                icon: 'success',
                                iconColor: '#CAAB55',
                                showConfirmButton: false,
                                timer: 4000
                            });
                        })
                }
            });

            Object.assign(formData, {
                nombre: '',
                apellidos: '',
                email: '',
                telefono: '',
                nivel: '',
                carrera: '',
                modelo: ''
            });
            
            activeStep.value = 1;
            showSuccess.value = true;

            // const result = await response.json();
            
            // if (result.error) {
            //     throw new Error(result.error);
            // }

            // Swal.fire({
            //     title: '¡ENVIADO!',
            //     text: 'NUESTROS EJECUTIVOS SE PONDRÁN EN CONTACTO CONTIGO',
            //     icon: 'success',
            //     timer: 4000 
            // });

            // Resetear formulario
            // Object.keys(formData).forEach(key => {
            //     if (key !== 'campus' && key !== 'plantel' && key !== 'estado' && key !== 'localidad') {
            //         formData[key as keyof typeof formData] = ''
            //     }
            // });

        } catch (error) {
            Swal.fire({
                title: 'Error al enviar el formulario',
                text: `${error}`,
                icon: 'error',
                timer: 4000,
                iconColor: '#881912',
                showConfirmButton: false,
                timerProgressBar: true,
            });
            console.error(error);
        }
    }

    const showError = (message: string) => {
        Swal.fire({
            text: message,
            toast: true,
            position: 'top-end',
            timer: 4000,
            icon: 'error',
            width: 500,
            padding: '1em',
            showConfirmButton: false,
            timerProgressBar: true,
            iconColor: '#881912'
        });
    }

    watch(carreras, (newCarreras: string|any[]) => {
        if (newCarreras.length === 1) {
            formData.carrera = newCarreras[0].value
            loadModelos() // Cargar modelos automáticamente si hay solo 1 carrera
        }
    });

    // Watcher para modelos
    watch(modelos, (newModelos: string|any[]) => {
        if (newModelos.length === 1) {
            formData.modelo = newModelos[0].value
        }
    });

    onMounted(() => {
        loadNiveles();
        //@ts-ignore
        grecaptcha.enterprise.ready(async () => {
            //@ts-ignore
            const token = await grecaptcha.enterprise.execute('6Ldd0x0oAAAAAAaPVjMnVirgyfT6qahpksCqN0UX', {
                action: 'submit_lead'
            })
            formData.recaptcha = token;
        });
    });
</script>

<template>
    <NavbarLanding class="fixed top-0 left-0 w-full " />

    <section 
        id="oferta-edu"
        class="bg-cover bg-[center] flex items-center justify-center bg-no-repeat mb-8 pt-[88px] lg:pt-[163px] lg:mb-14 w-screen lg:h-screen h-auto py-0"
        :style="{ 
            backgroundImage: 'url(/pagesImages/landing-virtual-encabezado-mapa-claro.webp)',
        }"
    >
        <div class="relative lg:container mx-auto w-full max-w-4xl lg:max-w-[1200px]">
            <div class="flex flex-col lg:flex-row justify-center items-center font-montse my-2 md:px-4">
                <div class="order-1 flex justify-between items-center w-full lg:w-2/3">
                    <div class="flex flex-col justify-center items-center lg:items-start w-full lg:my-0 my-12 text-white">
                        <h1  class="lg:text-3xl text-xl lg:text-left text-center uppercase mb-3 leading-tight " style="letter-spacing: 4px; text-shadow: 1px 1px 0px black, -1px 1px 0px black, 1px -1px 0px black, -1px -1px 0px black, 0 4px 6px rgba(0, 0, 0, 1);">
                            <span class="block lg:text-3xl md:text-xl text-[18px]">Campus Virtual</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block lg:text-5xl text-3xl">Internacional</span>
                        </h1>
                        <p class="text-left text-lg lg:text-xl mb-2 lg:mb-4 lg:px-0 px-8">
                            <span >"La tecnología acerca el conocimiento, pero la pasión lo hace tuyo.”</span><br>
                            <span ><em>(Inspirada en Steve Jobs)</em></span>
                        </p>
                    </div>
                </div>
                <div class="order-2 w-[85%] md:w-[80%] lg:w-1/3 bg-white/80 rounded-lg h-[500px] p-2 lg:p-4 text-xl">
                    <!-- <form @submit.prevent="submitForm" class="flex w-full h-full"> -->
                    <div class="flex w-full h-full ">
                        <div v-show="!showSuccess" class="flex flex-col text-gray-600 justify-between w-full h-full">
                            <!-- Paso 1 -->
                            <div v-show="activeStep === 1">
                            <!-- Campos de contacto -->
                                <p class="text-[#73793B] text-center font-serif my-2 text-[32px]">Contáctanos</p>
                                <div class="flex items-center"
                                    v-for="field in fields"
                                    :key="field.id"
                                >
                                    <i class=" mr-2" :class="field.icon"></i>
                                    <label class="label">
                                        <input 
                                            v-model="formData[field.id]"
                                            type="text" 
                                            :name="field.id" 
                                            :id="field.id"
                                            class="input"
                                            required
                                        >
                                        <span class="span">{{ field.label }}</span>
                                    </label>
                                </div>
                            </div>

                            <!-- Paso 2 -->
                            <div v-show="activeStep === 2" class="flex-col justify-between w-full h-full">
                                <!-- Selectores de estudios -->
                                <div class="flex items-center w-full pb-6">
                                    <i class="  text-gray-600 mr-2 pt-5"></i>
                                    <div class="flex flex-col items-start w-full">
                                        <label class="text-gray-600 text-[.975rem]">&iquest;Qu&eacute; quieres estudiar&quest; *</label>
                                        <select v-model="formData.nivel" @change="loadCarreras" class="p-1 bg-transparent border-b-2 border-gray-600 w-full" required>
                                            <!-- <option v-show="niveles.length > 0" value="" selected>Selecciona una opci&oacute;n</option> -->
                                            <option v-for="nivel in niveles" :value="nivel.value" :selected="niveles.length === 1">{{ nivel.text }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="flex items-center w-full pb-6">
                                    <i class=" text-gray-600 mr-2 pt-5"></i>
                                    <div class="flex flex-col items-start w-full">
                                        <label class="text-gray-600 text-[.975rem]">Carrera *</label>
                                        <select v-model="formData.carrera" @change="loadModelos" class="p-1 bg-transparent border-b-2 border-gray-600 w-full" required>
                                            <!-- <option v-show="carreras.length > 1" value="" selected>Selecciona una opci&oacute;n</option> -->
                                            <option v-for="carrera in carreras" :value="carrera.value" :selected="niveles.length === 1">{{ carrera.text }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="flex items-center w-full">
                                    <i class=" text-gray-600 mr-2 pt-5"></i>
                                    <div class="flex flex-col items-start w-full">
                                        <label class="text-gray-600 text-[.975rem]">Modelo educativo *</label>
                                        <select v-model="formData.modelo" class="p-1 bg-transparent border-b-2 border-gray-600 w-full" required>
                                            <!-- <option v-show="modelos.length > 1" value="" selected>Selecciona una opci&oacute;n</option> -->
                                            <option v-for="modelo in modelos" :value="modelo.value" :selected="niveles.length === 1">{{ modelo.text }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <!-- Botones de navegación -->
                            <div class="flex mt-2 w-full"
                                :class="{
                                    'justify-center': activeStep === 1,
                                    'justify-between': activeStep === 2
                                }"
                            >
                                <button 
                                    v-if="activeStep === 2"
                                    @click="handleStep('prev')"
                                    class="text-base  bg-[#73793B] border rounded-none border-[#73793B] hover:bg-[#73793B]/80 text-white py-3 px-4 uppercase"
                                >
                                    Atr&aacute;s
                                </button>
                                
                                <button 
                                    v-if="activeStep === 1"
                                    @click="handleStep('next')"
                                    class="text-base  bg-[#73793B] border rounded-none border-[#73793B] hover:bg-[#73793B]/80 text-white py-3 px-4 uppercase"
                                >
                                    Siguiente
                                </button>
                                
                                <button 
                                    v-if="activeStep === 2"
                                    @click="submitForm"
                                    class="text-base  bg-[#73793B] border rounded-none border-[#73793B] hover:bg-[#73793B]/80 text-white py-3 px-4 uppercase"
                                >
                                    Solicitar informes
                                </button>
                            </div>
                        </div>

                        <!-- Mensaje de éxito -->
                        <div v-show="showSuccess" class="flex flex-col justify-center items-center">
                            <div class="font-bold text-2xl">
                                <p class="font-montse text-gray-600 mb-5 text-center">
                                    Tus datos han sido enviados.
                                </p>
                                <p class="font-montse text-gray-600 mb-5 text-center">
                                    Nuestros ejecutivos se pondr&aacute;n en contacto contigo.
                                </p>
                            </div>
                            <div class="flex justify-center mb-5">
                                <img src="/pagesImages/humanitas-logo.png" alt="Humanitas" class="h-[100px]">
                                <!-- <img src="./compImages/humanitas-logo.png" alt="Humanitas" class="h-[100px]"> -->
                            </div>
                            <button 
                                @click="showSuccess = false"
                                class="text-base  bg-hgold border rounded-none border-hgold hover:bg-hwine text-white py-3 px-4 uppercase"
                            >
                                Enviar de nuevo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
    .label {
        display: grid;
        width: 100%;
        padding: 1.5rem 0;
        margin-top: 0.5rem;

        grid-template-areas: "input";

        >* {
            grid-area: input;
        }
    }

    .span {
        transform-origin: left;
        --tw-text-opacity: 1;
        /* color: rgb(94 41 42 / var(--tw-text-opacity)); */
        color: #4b5563;
        transition: transform .3s, color .3s;
        font-size: 1.25rem/* 16px */;
        line-height: 1.75rem/* 24px */;
        font-weight: 500;
        padding: 0.25rem;
        text-align: left;
    }

    .input {
        height: 100%;
        width: 100%;
        padding: 0.25rem;
        background-color: transparent;
        font-weight: 700;
        border: none;
        outline: none;
        border-bottom: 2px solid #4b5563;
        font: inherit;

        &:focus + .span,
        &:not(:placeholder-shown) + .span {
            color: #4b5563;
            transform: translate(0, -100%) scale(.8);
            font-weight: 400;
        }
    }
</style>